import { render, staticRenderFns } from "./EventSuperAdminFilteredTemplate.vue?vue&type=template&id=601107f0&"
import script from "./EventSuperAdminFilteredTemplate.vue?vue&type=script&lang=ts&"
export * from "./EventSuperAdminFilteredTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports